import { i18n } from '@/i18n'

export default Validator => {
  Validator.register(
    'webhookurl',
    function (value = '') {
      if (value.startsWith('/api/integration/')) return true
      return /https:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_\+.~#?&/=]*)/i.test(value)
    },
    i18n.t('invalidUrl', { x: ':attribute' }),
  )
}
